import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CodeTextPageComponent } from './component/code-text-page/code-text-page.component';

const routes: Routes = [
    {
        path: '',
        component: CodeTextPageComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CodeTextRoutingModule {}
